<template>
  <div class="mb-6">
    <v-card class="rounded-xl overflow-hidden" elevation="3">
      <v-app-bar flat color="white" height="70">
        <v-avatar color="primary" size="42" class="mr-3 elevation-2">
          <v-icon dark>mdi-swap-horizontal-bold</v-icon>
        </v-avatar>
        
        <div class="d-flex flex-column">
          <v-toolbar-title class="font-weight-bold text-h6 primary--text" style="line-height: 1.2;">
            ระบบบริหารการย้าย
          </v-toolbar-title>
          <span class="caption grey--text text--darken-1 d-none d-sm-flex">
            Teacher Transfer Management System
          </span>
        </div>

        <v-spacer></v-spacer>

        <div class="d-none d-md-flex">
          
          <v-menu offset-y open-on-hover transition="slide-y-transition" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn 
                text 
                rounded 
                v-bind="attrs" 
                v-on="on"
                class="text-capitalize mr-1"
                :color="isGroupActive(group1_routes) ? 'primary' : 'grey darken-1'"
              >
                <v-icon left>mdi-cogs</v-icon>
                ตั้งค่า & ข้อมูล
                <v-icon right small>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list dense class="rounded-lg py-2" elevation="4">
              <v-subheader class="text-uppercase font-weight-bold grey--text text--small">ข้อมูลพื้นฐาน</v-subheader>
              <v-list-item v-for="(item, i) in group1_items" :key="i" :to="item.to" color="primary">
                <v-list-item-icon class="mr-3"><v-icon small>{{ item.icon }}</v-icon></v-list-item-icon>
                <v-list-item-content><v-list-item-title>{{ item.text }}</v-list-item-title></v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-menu offset-y open-on-hover transition="slide-y-transition" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn 
                text 
                rounded 
                v-bind="attrs" 
                v-on="on"
                class="text-capitalize mr-1"
                :color="isGroupActive(group2_routes) ? 'primary' : 'grey darken-1'"
              >
                <v-icon left>mdi-account-group</v-icon>
                ผู้ขอย้าย
                <v-icon right small>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list dense class="rounded-lg py-2" elevation="4">
              <v-subheader class="text-uppercase font-weight-bold grey--text text--small">ข้อมูลผู้ยื่นคำร้อง</v-subheader>
              <v-list-item v-for="(item, i) in group2_items" :key="i" :to="item.to" color="primary">
                <v-list-item-icon class="mr-3"><v-icon small>{{ item.icon }}</v-icon></v-list-item-icon>
                <v-list-item-content><v-list-item-title>{{ item.text }}</v-list-item-title></v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-menu offset-y open-on-hover transition="slide-y-transition" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn 
                text 
                rounded 
                v-bind="attrs" 
                v-on="on"
                class="text-capitalize mr-1"
                :color="isGroupActive(group3_routes) ? 'primary' : 'grey darken-1'"
              >
                <v-icon left>mdi-calculator-variant</v-icon>
                ประมวลผล
                <v-icon right small>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list dense class="rounded-lg py-2" elevation="4">
              <v-subheader class="text-uppercase font-weight-bold grey--text text--small">ขั้นตอนการประมวลผล</v-subheader>
              <v-list-item v-for="(item, i) in group3_items" :key="i" :to="item.to" color="primary">
                <v-list-item-icon class="mr-3"><v-icon small :color="item.color">{{ item.icon }}</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                  <v-list-item-subtitle class="caption">{{ item.sub }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-menu offset-y open-on-hover transition="slide-y-transition" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn 
                text 
                rounded 
                v-bind="attrs" 
                v-on="on"
                class="text-capitalize"
                :color="isGroupActive(group4_routes) ? 'primary' : 'grey darken-1'"
              >
                <v-icon left>mdi-file-chart</v-icon>
                รายงานผล
                <v-icon right small>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list dense class="rounded-lg py-2" elevation="4">
              <v-subheader class="text-uppercase font-weight-bold grey--text text--small">สรุปและรายงาน</v-subheader>
              <v-list-item v-for="(item, i) in group4_items" :key="i" :to="item.to" color="primary">
                <v-list-item-icon class="mr-3"><v-icon small>{{ item.icon }}</v-icon></v-list-item-icon>
                <v-list-item-content><v-list-item-title>{{ item.text }}</v-list-item-title></v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

        <v-menu bottom left transition="scale-transition" origin="top right">
          <template v-slot:activator="{ on, attrs }">
             <v-btn icon v-bind="attrs" v-on="on" class="d-md-none">
               <v-icon>mdi-menu</v-icon>
             </v-btn>
          </template>
          <v-list nav dense class="rounded-lg">
             <v-list-group prepend-icon="mdi-cogs" no-action>
                <template v-slot:activator><v-list-item-title>ตั้งค่า & ข้อมูล</v-list-item-title></template>
                <v-list-item v-for="(item, i) in group1_items" :key="i" :to="item.to">
                   <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
             </v-list-group>

             <v-list-group prepend-icon="mdi-account-group" no-action>
                <template v-slot:activator><v-list-item-title>ผู้ขอย้าย</v-list-item-title></template>
                <v-list-item v-for="(item, i) in group2_items" :key="i" :to="item.to">
                   <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
             </v-list-group>

             <v-list-group prepend-icon="mdi-calculator-variant" no-action>
                <template v-slot:activator><v-list-item-title>ประมวลผล</v-list-item-title></template>
                <v-list-item v-for="(item, i) in group3_items" :key="i" :to="item.to">
                   <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
             </v-list-group>

             <v-list-group prepend-icon="mdi-file-chart" no-action>
                <template v-slot:activator><v-list-item-title>รายงานผล</v-list-item-title></template>
                <v-list-item v-for="(item, i) in group4_items" :key="i" :to="item.to">
                   <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
             </v-list-group>
          </v-list>
        </v-menu>

      </v-app-bar>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "HRvecMovementMenu",
  data() {
    return {
      // Group 1: Configuration & Basic Data
      group1_items: [
        { text: "กำหนดการ", icon: "mdi-calendar-clock", to: "/admin/timelines/transfer_teachers" },
        { text: "รายละเอียดเงื่อนไขสาขา", icon: "mdi-format-list-checks", to: "/admin/conditions_branch" },
        { text: "รายการเงื่อนไขสาขา", icon: "mdi-playlist-check", to: "/admin/conditions_transfer" },
        { text: "ข้อมูลอัตรากำลังรับย้าย", icon: "mdi-seat", to: "/admin/man_power" },
        { text: "ข้อมูลอัตรากำลังขาดเกิน", icon: "mdi-chart-bar", to: "/admin/man_powersummary" },
      ],
      
      // Group 2: Applicants
      group2_items: [
        { text: "รายละเอียดผู้ยื่นขอย้าย", icon: "mdi-account-details", to: "/admin/transference_location_detail" },
        { text: "รายการผู้ยื่นขอย้าย", icon: "mdi-account-search", to: "/admin/transference_location" },
        { text: "ประมวลผล 1 (คัดกรอง)", icon: "mdi-filter-outline", to: "/admin/transference_personnel" },
      ],
      
      // Group 3: Processing
      group3_items: [
        { text: "ประมวลผล 2 (ระบบ)", icon: "mdi-robot", color: "blue", sub: "จับคู่ตำแหน่งว่างอัตโนมัติ", to: "/admin/process_transfer" },
        { text: "ประมวลผล 3 (สับเปลี่ยนปกติ)", icon: "mdi-swap-horizontal", color: "green", sub: "สับเปลี่ยนระหว่างบุคคล", to: "/admin/process_transfer_switch_normal" },
        { text: "ประมวลผล 4 (สับเปลี่ยน)", icon: "mdi-swap-horizontal-bold", color: "orange", sub: "สับเปลี่ยนกรณีพิเศษ", to: "/admin/process_transfer_switch" },
      ],

      // Group 4: Reports
      group4_items: [
        { text: "สรุปผลการย้าย", icon: "mdi-check-decagram", to: "/admin/conditons_transfer_success" },
        { text: "รายงานคำสั่งแต่งตั้ง", icon: "mdi-file-document-outline", to: "/admin/Order_appoint" },
        { text: "สถานะการรายงานตัว", icon: "mdi-account-check-outline", to: "/admin/conditons_transfer_success_reportmv" },
      ]
    };
  },
  computed: {
    // Helper to get routes for checking active state
    group1_routes() { return this.group1_items.map(i => i.to); },
    group2_routes() { return this.group2_items.map(i => i.to); },
    group3_routes() { return this.group3_items.map(i => i.to); },
    group4_routes() { return this.group4_items.map(i => i.to); },
  },
  methods: {
    isGroupActive(routes) {
      if (!this.$route || !this.$route.path) return false;
      return routes.some(route => this.$route.path.startsWith(route));
    }
  }
};
</script>

<style scoped>
.v-menu__content {
  border-radius: 12px !important;
}
</style>